import OverviewConfig from './overview/OverviewConfig';
import { Navigate } from 'react-router-dom';
import i18next from 'i18next';
import enGB from '@locales/billbuddy/enGB';
import deAT from '@locales/billbuddy/deAT';

i18next.addResourceBundle('enGB', 'billbuddy', enGB);
i18next.addResourceBundle('deAT', 'billbuddy', deAT);

const BillbuddyConfigs = [
	OverviewConfig,
	{
		routes: [
			{
				path: '/bb',
				exact: true,
				element: <Navigate to="/bb/overview" />,
			}
		]
	}
];

export default BillbuddyConfigs;
